/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 1/28/20.
 */

function ExternalIngestsTabController(
    this: JS5Object,
    $q: JS5Object,
    $timeout: JS5Function,
    $window: JS5Object,
    uiGridConstants: JS5Object,
    AggregationResourceFactory: JS5Object,
    DownloadAssetService: JS5Object,
    EndPointService: JS5Object,
    PackageResourceFactory: JS5Object,
    PackageUtilService: JS5Object,
    PermissionsService: JS5Object,
    UtilsService: JS5Object,
) {

    const PACKAGE_EXTERNAL_INGESTS_VIEW_STATE = 'PACKAGE_EXTERNAL_INGESTS_VIEW_STATE';

    //======//
    // Grid //
    //======//

    let gridColumnDefs = [
        {
            field: 'aggregationDate',
            width: 250,
            cellTemplate: 'components/visual/grid/date-time-column-template.html'
        },
        {
            displayName: 'Completed',
            field: 'completed',
            width: 90,
            cellTemplate: 'components/visual/grid/boolean-flag-checkmark-template.html',
        },
        {
            displayName: 'Source Link',
            field: 'sourceFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Source Filename',
            field: 'sourceFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            displayName: 'Transf. Link',
            field: 'transformedFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Transformed Filename',
            field: 'transformedFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
    ];

    let uriLookup: JS5Object = {};

    this.gridOptions = {
        enableColumnMenus: false,
        enableColumnResizing: false,
        enableFullRowSelection: false,
        enablePaginationControls: false,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        enableSorting: false,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: gridColumnDefs,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.getAssetURI = (assetVersionId: string) => {
        if (_.size(assetVersionId) <= 0) {
            return undefined;
        }
        return DownloadAssetService.getAssetUri(assetVersionId, 'document', DownloadAssetService.ContentUse.Source);
    };

    this.downloadFile = (taskUri: string) => {
        let file = uriLookup[taskUri];
        UtilsService.downloadFile(file.uri, file.filename);
    };


    //===================//
    // Template Response //
    //===================//

    this.areControlsEnabled = () => {
        return this.pkgEditCtrl.statusAllowsEdit() && !this.packageObject.locked && this.canWrite;
    };

    this.onExternalIdChange = () => {
        if (_.get(this.packageObject, 'externalId.length') == 0)
            this.packageObject.externalId = null;
    };

    this.clearExternalId = () => {
        this.packageObject.externalId = null;
        this.externalIngestsTabEditorForm.$setDirty();
    };

    this.clearExternalDateUpdated = () => {
        this.packageObject.externalDateUpdated = null;
        this.externalIngestsTabEditorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    const getEditData = () => {
        return AggregationResourceFactory.getTasks({
            packageId: this.packageObject.id,
            externalSystem: this.packageObject.externalSystem,
            externalId: this.packageObject.externalId,
        }).$promise.then((ingestLogs: JS5Object[]) => {
            this.gridOptions.data = ingestLogs;
            let uriPromises: JS5Object[] = [];
            _.forEach(ingestLogs, (ingestLog: JS5Object) => {
                const sourceFile: JS5Object = {
                    uri: `${EndPointService.aggregationEndPoint}/tasks/${ingestLog.id}/xml?sourceXml=true`,
                    filename: ingestLog.sourceFilename,
                }
                uriLookup[sourceFile.uri] = sourceFile;
                ingestLog.sourceFile = sourceFile;

                const transformedFile: JS5Object = {
                    uri: `${EndPointService.aggregationEndPoint}/tasks/${ingestLog.id}/xml?sourceXml=false`,
                    filename: UtilsService.appendBaseFilename(ingestLog.sourceFilename, '_transformed'),
                }
                uriLookup[transformedFile.uri] = transformedFile;
                ingestLog.transformedFile = transformedFile
            });
            return $q.all(uriPromises);
        }).then(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.$onInit = () => {
        this.loadingIndicator.show = true;
        this.canRead = false;
        this.canWrite = false;

        PermissionsService.getReadWritePermissions(PACKAGE_EXTERNAL_INGESTS_VIEW_STATE)
            .then((perms: JS5Object) => {
                this.canRead = perms.write || perms.read;
                this.canWrite = perms.write;
                if (this.canRead) {
                    return getEditData();
                }
            });
    };

    this.$postLink = () => {
        $timeout(() => {
            PackageUtilService.editorForm = this.externalIngestsTabEditorForm;
        });
    };
}

angular
    .module('prism-ui.package')
    .component('externalIngestsTab', {
        templateUrl: 'package/editor/components/view/externalIngests/external-ingests-tab-template.html',
        controller: ExternalIngestsTabController,
        bindings: {
            packageObject: '<',
            loadingIndicator: '<',
            pkgEditCtrl: '<',
        }
    });
